"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotApiForm = void 0;
const tslib_1 = require("tslib");
/**
 * Creates and provide methods to render a DotCMS Form
 *
 */
class DotApiForm {
    constructor(dotApiContentType, formConfig) {
        this.dotApiContentType = dotApiContentType;
        this.formConfig = formConfig;
    }
    /**
     * Render form on provided html element
     * @memberof DotApiForm
     */
    get() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.dotApiContentType.get(this.formConfig.identifier);
        });
    }
}
exports.DotApiForm = DotApiForm;
